import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { MapMarker } from '@application/Interfaces/Molecules'
import { TitleDescriptionMapType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Map } from '@organisms/Map'

import { Button, Container, Description, Link, PortLink, PortName, Title, Wrapper } from './TitleDescriptionMap.styled'

export const TitleDescriptionMap = (props: TitleDescriptionMapType): JSX.Element => {
    const { title, description, buttonLink, buttonLabel, mode, ports, latitude, longitude } = props

    const showTitleOnLeft = description?.data.childMarkdownRemark.html || (buttonLink && buttonLabel)

    return (
        <Wrapper $mode={mode}>
            <Container>
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        sm={showTitleOnLeft ? 6 : 12}
                        mdUpSpacingRight={6}
                        mdUpSpacingBottom={showTitleOnLeft ? 0 : 6}
                        mdDownSpacingBottom={6}
                    >
                        <Title>{title}</Title>
                        {description?.data.childMarkdownRemark.html && (
                            <Description>
                                <Html content={description.data.childMarkdownRemark.html} />
                            </Description>
                        )}
                        <Grid container spacingTop={6}>
                            {ports.map((p) => {
                                if (p.link) {
                                    return (
                                        <Grid key={p.title} item xs={6} sm={showTitleOnLeft ? 6 : 4}>
                                            <PortLink to={p.link}>{p.title}</PortLink>
                                        </Grid>
                                    )
                                }

                                return (
                                    <Grid key={p.title} item xs={6} sm={showTitleOnLeft ? 6 : 4}>
                                        <PortName>{p.title}</PortName>
                                    </Grid>
                                )
                            })}
                        </Grid>
                        {buttonLink && buttonLabel && (
                            <Link to={buttonLink}>
                                <Button icon={<ArrowDirectionIcon />}>{buttonLabel}</Button>
                            </Link>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={showTitleOnLeft ? 6 : 12} sx={{ minHeight: 400 }}>
                        <Map defaultCenter={{ lat: +latitude, lng: +longitude }}>
                            {ports.map((port, index) => (
                                <MapMarker
                                    key={port.title}
                                    title={port.title}
                                    lat={parseFloat(port.latitude)}
                                    lng={parseFloat(port.longitude)}
                                />
                            ))}
                        </Map>
                    </Grid>
                </Grid>
            </Container>
        </Wrapper>
    )
}
